var React = require('react');

function ArrowAltCircleUp (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.84 248.16h-71.51V372a12.08 12.08 0 0 1-12.1 12h-64.56a12.08 12.08 0 0 1-12.1-12V256.16h-71.41c-10.79 0-16.24-12.89-8.57-20.48l115.89-114.16a12.08 12.08 0 0 1 17 0l115.93 114.16c7.67 7.49 2.22 20.48-8.57 20.48z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M288.23 384h-64.56a12.08 12.08 0 0 1-12.1-12V256.16h-71.41c-10.79 0-16.24-12.89-8.57-20.48l115.89-114.16a12.08 12.08 0 0 1 17 0l115.93 114.16c7.67 7.49 2.22 20.48-8.57 20.48h-71.51V372a12.08 12.08 0 0 1-12.1 12z","className":"fa-primary","key":2})]);
}

ArrowAltCircleUp.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = ArrowAltCircleUp;

ArrowAltCircleUp.default = ArrowAltCircleUp;
